import Scriba from 'react-scriba';

export class DataRapport {

    static _chargementDesRapports(idRapportCategorie) {
        let objet = {
            "idRapportCategorie": idRapportCategorie,
        };

        var url = "api/Liste/ListeDesRAPPORTS";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onGetRapport(typeFormat, rapport, dateCG) {
        let objet = {
            "typeFormat": typeFormat,
            "rapport": rapport,
            "dateReference": dateCG
        };

        var url = "api/Download/GetRapport";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

}
